import { BP42Action } from '@r1-frontend/bp42/constants/actions';

import { IAction } from '@r1-frontend/shared/types/Redux';

const setLoading = (state: boolean): IAction<BP42Action.Loading, { state: boolean }> => ({
    type: BP42Action.Loading,
    payload: {
        state,
    },
});

export default setLoading;
